// Hideo - interface state shared by the Vue shell and the legacy code: the phone menu, the online-save status, the warning
// dot on the profile button and the refresh tick (bumped by the legacy renderAll and by refreshVue, so Vue pages that
// read legacy state redraw).
import { defineStore } from 'pinia'
import { ref } from 'vue'

/** Online save status (from syncView in src/features/cloud/autosync.ts): the indicator at the top right (TopControls.vue) and the dot on the
 *  phone's profile button (MobileBar.vue) */
export interface SyncView {
  /** Font Awesome icon classes */
  icon: string
  /** Colour classes of the icon */
  cls: string
  /** Short text (computer) */
  txt: string
  /** Tooltip */
  tip: string
}

export const useUiStore = defineStore('ui', () => {
  const mobileMenuOpen = ref(false)
  /** null = nothing to show (opened as a file, no profile) */
  const sync = ref<SyncView | null>(null)
  /** Warning dot on the profile button (data.js refreshWarn): its tooltip, '' = hidden */
  const profileWarn = ref('')
  const tick = ref(0)
  const refresh = () => { tick.value++ }
  const openMobileMenu = () => { mobileMenuOpen.value = true }
  const closeMobileMenu = () => { mobileMenuOpen.value = false }
  const toggleMobileMenu = () => { mobileMenuOpen.value = !mobileMenuOpen.value }
  return { mobileMenuOpen, sync, profileWarn, tick, refresh, openMobileMenu, closeMobileMenu, toggleMobileMenu }
})
